<template>
  <div id="revisi">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>
        <router-link :to="{path: '/tryouts'}">Tryout</router-link>
      </li>
      <li class="active">Revisi</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Revisi Tryout</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="btn-group pull-right"><button type="button" class="btn btn-success btn-xs" @click="save()"><span class="fa fa-download"></span> Simpan</button></div>
            <h4 class="panel-title">{{$store.state.tryout.name}} ({{$store.state.tryout.code}})</h4>
          </div>
          <div class="panel-body">
            <div class="form-group">
              <div class="col-md-6">
                <select class="form-control" v-model="subtestCode">
                  <option disabled value="">-- Pilih Subtest --</option>
                  <option v-for="subtest in subtests" v-bind:key="subtest.bundle_code" :value="subtest.subtest_code">{{subtest.subject_name}}</option>
                </select>
                
              </div>
            </div>
            <div class="form-group" v-if="subtestCode != ''">
              <div class="col-md-6">
                <table class="table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>No.</th>
                      <th>Kode</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in items" v-bind:key="index">
                      <td><img :src="subjectPicture" height="25px"></td>
                      <td>{{item.sequence}}</td>
                      <td>
                      <app-itemchooser :subject="subjectData" :topiclist="topics" :placeholder="item.item_code" v-on:selected="updateItem(index, $event)"></app-itemchooser>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FileService from '@/services/file.js'
import TryoutService from '@/services/tryout.js'
import Marked from 'marked'
import ItembankService from '@/services/itembank.js'
import ItemChooser from '@/components/plugins/ItemChooser'

export default {
  name: 'revisi-tryout',
  components: {
    'app-itemchooser': ItemChooser
  },
  data: function() {
    return {
      subtests: [],
      subjectData: null,
      subjectPicture: null,
      items: [],
      subtestCode: '',
      bundleFileData: null,
      keyFileData: null,
      tryout: null,
      showItemChooser: false,
      topics: null
    }
  },
  methods: {
    initData: function() {
      var context = this
      var code = this.$store.state.tryout.code
      var category = this.$store.state.tryout.category
      var bundleFileName = code + '_01001_' + category + '.json'
      var keyFileName = 'KEY_' + bundleFileName

      var bundleFilePath = 'bundles/' + code + '/' + bundleFileName
      var keyFilePath = 'bundles/' + code + '/keys/' + keyFileName

      FileService.download(bundleFilePath, function(response) {
        if (response.success) {
          context.subtests = response.data.subtests
          context.bundleFileData = response.data
        }
      })

      FileService.download(keyFilePath, function(response) {
        if (response.success) context.keyFileData = response.data
      })
    },
    updateItem: function(index, newItem) {
      var context = this
      var itemId = newItem.id
      ItembankService.getItemById(itemId, function(response) {
        if (response.success) {
          try {
            var soal = Marked(response.data.isi, { sanitize: false });
            var wacana = response.data.wacana != null ? Marked(response.data.wacana.isi, { sanitize: false }) : null
            var pilihan1 = response.data.pilihan_1 != null ? Marked(response.data.pilihan_1, { sanitize: false }) : null
            var pilihan2 = response.data.pilihan_2 != null ? Marked(response.data.pilihan_2, { sanitize: false }) : null
            var pilihan3 = response.data.pilihan_3 != null ? Marked(response.data.pilihan_3, { sanitize: false }) : null
            var pilihan4 = response.data.pilihan_4 != null ? Marked(response.data.pilihan_4, { sanitize: false }) : null
            var pilihan5 = response.data.pilihan_5 != null ? Marked(response.data.pilihan_5, { sanitize: false }) : null

            var itemCode = context.$store.state.tryout.code + '_' + response.data.kode
            var itemData = {
              isAnchor: true,
              item_code: itemCode,
              sequence: index+1,
              soal: soal,
              wacana: wacana,
              pilihan: [
                {key: 'A', value: pilihan1},
                {key: 'B', value: pilihan2},
                {key: 'C', value: pilihan3},
                {key: 'D', value: pilihan4},
                {key: 'E', value: pilihan5}
              ]
            }

            var oldItem = context.items[index]
            context.items[index] = itemData

            var explanation = response.data.pembahasan != null ? Marked(response.data.pembahasan, { sanitize: false }) : null
            var keyData = {
              eigen_score: response.data.nilai_eigen,
              explanation: explanation,
              item_code: itemCode,
              key: response.data.jawaban,
              weight_score: 1
            }

            var keyIndex = context.keyFileData.findIndex(function(key) {
              return key.item_code === oldItem.item_code
            })

            context.keyFileData[keyIndex] = keyData
            context.$forceUpdate()
            window.alert('Soal No. ' + (index+1) + ' : ' + oldItem.item_code
              + ' berhasil diganti dengan: ' + itemData.item_code)
          } catch(e) {
            console.log(e)
          }
        }
      })
    },
    save: function() {
      var confirmed = window.confirm("Apakah anda yakin untuk menyimpan perubahan ini?")
      if (confirmed) {
        var context = this
        var index = this.bundleFileData.subtests.findIndex(function(subtest) {
          return subtest.subtest_code == context.subtestCode
        })

        this.bundleFileData.subtests[index].items = this.items

        var file = new Blob([JSON.stringify(this.bundleFileData)], {type: 'application/octet-stream'})
        var code = this.$store.state.tryout.code
        var category = this.$store.state.tryout.category
        var path = code + '/' + code + '_01001_' + category + '.json'
        FileService.adminBundleUpload(file, path, function(response) {
          console.log(response)
          if (response.success) window.alert("Data berhasil di simpan!")
        })

        var keyFile = new Blob([JSON.stringify(this.keyFileData)], {type: 'application/octet-stream'})
        var keyPath = code + '/keys/KEY_' + code + '_01001_' + category + '.json'
        FileService.adminBundleUpload(keyFile, keyPath, function(response) {
          console.log(response)
        })
      }
    },
    loadTopicData(newVal) {
      var context = this
      var selectedSubtest = context.bundleFileData.subtests.filter(subtest => subtest.subtest_code == newVal)[0]
      ItembankService.getListOfTopic(selectedSubtest.subtest_code.split('_')[1], function(result) {
        context.topics = []
        if (result.success) {
          result.data.forEach(function(topic) {
            context.topics.push(topic)
          })
        }

        context.subjectData = {
          name: selectedSubtest.subject_name,
          code: selectedSubtest.subtest_code.split('_')[1],
          picture: selectedSubtest.subject_picture
        }
        context.items = selectedSubtest.items
        context.subjectPicture = selectedSubtest.subject_picture
      })
    },
  },
  watch: {
    subtestCode: function(newVal, oldVal) {
      this.loadTopicData(newVal)
    }
  },
  mounted: function() {
    var context = this
    var tryoutId = this.$route.query.id
    TryoutService.getTryoutById(tryoutId, function(response) {
      if (response.success) {
        context.$store.commit('tryout_init', response.data)
        context.initData()
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// Revisi.vue?f567c55e